import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import { Toaster } from './components/ui/sonner';

function App() {
  useEffect(() => {
    // Remove only Emergent branding badge - more specific targeting
    const removeEmergentBadge = () => {
      // Look for specific badge elements
      const badges = document.querySelectorAll('a[href*="emergent.sh"], a[href*="emergentagent.com"]');
      badges.forEach(badge => {
        // Hide the badge and its parent container
        if (badge && badge.textContent.includes('Made with')) {
          badge.style.display = 'none';
          if (badge.parentElement) {
            const parent = badge.parentElement;
            const parentStyles = window.getComputedStyle(parent);
            if (parentStyles.position === 'fixed') {
              parent.style.display = 'none';
            }
          }
        }
      });
    };
    
    // Run after a short delay to allow page to load
    const timer = setTimeout(removeEmergentBadge, 1000);
    
    // Also run on any DOM changes
    const observer = new MutationObserver(() => {
      setTimeout(removeEmergentBadge, 100);
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacidade" element={<PrivacyPolicy />} />
          <Route path="/termos" element={<TermsOfService />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;